import { render } from "./StepOrganization.vue?vue&type=template&id=74325876"
import script from "./StepOrganization.vue?vue&type=script&lang=js"
export * from "./StepOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__